module.exports = __webpack_public_path__ + "img/shamrock.1556bc14.png";